import { useBootstrapStores } from '@/hooks/useBootstrapStores';
import { useMetaStore } from '@/engine/state';
import { CosmicGameOver } from '@/components/layout/CosmicGameOver';
import { GameOverMuerte } from '@/components/layout/GameOverMuerte';
import { ScreenEffects } from '@/components/effects/ScreenEffects';
import { AppRouter } from './AppRouter';

export function AppShell() {
  const listo = useBootstrapStores();
  const cosmico = useMetaStore((s) => s.cosmicGameOverActivo);
  const muerte = useMetaStore((s) => s.gameOverMuerteActivo);

  if (!listo) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <div className="text-ash-400 fluid-xs font-ui tracking-widest uppercase animate-pulse">
          invocando recuerdos…
        </div>
      </div>
    );
  }

  if (cosmico) return <CosmicGameOver />;
  if (muerte) return <GameOverMuerte />;

  return (
    <>
      <AppRouter />
      <ScreenEffects />
    </>
  );
}
